import React from 'react'
import Liked from '../Components/Liked/Liked'
const Mostliked = () => {
  return (
    <div><Liked/></div>
  )
}

export default Mostliked
